"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.RIDE_HAILING_ENDPOINT = {
    postCreateBooking: '/svc/ride-hailing/bookings/bookings',
    getVehicleCategories: '/svc/ride-hailing/bookings/vehicle-categories',
    getDetailBooking: '/svc/ride-hailing/bookings/bookings/{{bookingUuid}}',
    getBookingAndChauffeurDetails: '/svc/ride-hailing/bookings/meet-driver?booking_uuid={{bookingUuid}}',
    cancelBooking: '/svc/ride-hailing/bookings/bookings/{{bookingId}}/status',
    patchEnableVehicleCategories: '/svc/ride-hailing/bookings/company-settings/{{companyUuid}}/vehicle-categories',
    getCompanyVehicleCategories: '/svc/ride-hailing/bookings/company-settings/{{companyUuid}}/vehicle-categories',
};
